import { render } from "./DzyyView.vue?vue&type=template&id=30f31b88&scoped=true"
import script from "./DzyyView.vue?vue&type=script&lang=js"
export * from "./DzyyView.vue?vue&type=script&lang=js"

import "./DzyyView.vue?vue&type=style&index=0&id=30f31b88&scoped=true&lang=stylus"

import exportComponent from "D:\\GameProject\\h5yaoji\\H5-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f31b88"]])

export default __exports__